import { render, staticRenderFns } from "./BloqueoPti.vue?vue&type=template&id=47aa06b5"
import script from "./BloqueoPti.vue?vue&type=script&lang=js"
export * from "./BloqueoPti.vue?vue&type=script&lang=js"
import style0 from "./BloqueoPti.vue?vue&type=style&index=0&id=47aa06b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports